import { apiClient } from '@/libs/http-client';

const prefixUrl = import.meta.env.VITE_MIDDLEWARE_BASE_URL;

export const checkSharpness = (imageString: string) => {
  return apiClient().post(`checkSharpness`, { prefixUrl, json: { imageString } }).json();
};
